import { DriverQualificationsType } from "../types/contracts"

export const QUALIFICATION_TYPES_LUKSEMBOURG = [
  DriverQualificationsType.NotSet,
  DriverQualificationsType.UnqualifiedDriver,
  DriverQualificationsType.QualifiedDriver,
]

export const QUALIFICATION_TYPES_ITALY = [
  DriverQualificationsType.NotSet,
  DriverQualificationsType.VehiclesBelow8Group3,
  DriverQualificationsType.VehiclesAbove8Group3Super,
  DriverQualificationsType.CcnlC3,
  DriverQualificationsType.CcnlB3,
  DriverQualificationsType.CcnlA3,
  DriverQualificationsType.CcnlF2,
  DriverQualificationsType.CcnlE2,
  DriverQualificationsType.CcnlD2,
  DriverQualificationsType.CcnlH1,
  DriverQualificationsType.CcnlG1,
  DriverQualificationsType.CcnlI110,
  DriverQualificationsType.CcnlI116,
  DriverQualificationsType.CcnlL110,
  DriverQualificationsType.CcnlL116,
  DriverQualificationsType.CcnlL119,
]

export const QUALIFICATION_TYPES_FINLAND = [
  DriverQualificationsType.NotSet,
  DriverQualificationsType.FinlandBusDriver,
  DriverQualificationsType.TrackDriverWithTrailer,
  DriverQualificationsType.TractorDriver,
  DriverQualificationsType.RegularDriver,
]

export const QUALIFICATION_TYPES_BELGIUM = [
  DriverQualificationsType.NotSet,
  DriverQualificationsType.Guard,
  DriverQualificationsType.DriverDuringTraining,
  DriverQualificationsType.VhiclesBelow7,
  DriverQualificationsType.JouniorCourier,
  DriverQualificationsType.VehiclesAbove7Below15,
  DriverQualificationsType.SeniorCourier,
  DriverQualificationsType.VehiclesAbove15,
  DriverQualificationsType.BelgiumFirstGroup,
  DriverQualificationsType.BelgiumSecondGroup,
  DriverQualificationsType.BelgiumThirdGroup,
  DriverQualificationsType.BelgiumFourthGroup,
]

export const QUALIFICATION_TYPES_CZECH = [
  DriverQualificationsType.NotSet,
  DriverQualificationsType.RegularDriver,
  DriverQualificationsType.VehiclesAbove3Comma5Driver,
  DriverQualificationsType.BusDriver,
]

export const QUALIFICATION_TYPES_DENMARK = [
  DriverQualificationsType.NotSet,
  DriverQualificationsType.CarriageOfGoods,
  DriverQualificationsType.CabotageInPassengerTransport,
  DriverQualificationsType.TouristTransport,
]

export const QUALIFICATION_TYPES_FRANCE = [
  DriverQualificationsType.NotSet,
  DriverQualificationsType.VehiclesTo3Comma5,
  DriverQualificationsType.VehiclesFrom3Comma5To11,
  DriverQualificationsType.VehiclesFrom11To19,
  DriverQualificationsType.VehiclesAbove19,
  DriverQualificationsType.HighQualifiedTruckDriver,
  DriverQualificationsType.BusDriver,
  DriverQualificationsType.BusDriverAndConductor,
  DriverQualificationsType.TouristBusDriver,
  DriverQualificationsType.BigBusDriver,
]

export const QUALIFICATION_TYPES_AUSTRIA = [
  DriverQualificationsType.NotSet,
  DriverQualificationsType.VehiclesTo3Comma5Standard,
  DriverQualificationsType.VehiclesAbove3Comma5Below3Axis,
  DriverQualificationsType.VehiclesAbove3Comma5Abov3Axis,
  DriverQualificationsType.VehicleCombination,
  DriverQualificationsType.DangerousGoods,
  DriverQualificationsType.EmployeesWithSpecialistQualifications,
  DriverQualificationsType.ProfessionalDriverVehiclesAbove3Comma5Below3Axis,
  DriverQualificationsType.ProfessionalDriverVehiclesAbove3Comma5Abov3Axis,
  DriverQualificationsType.ProfessionalDriverVehicleCombination,
  DriverQualificationsType.TankDriver,
  DriverQualificationsType.TransportOfPeopleDriver,
  DriverQualificationsType.TransportOfPeopleProfessionalDriver,
  DriverQualificationsType.TransportOfPeopleQualifiedWorker,
  DriverQualificationsType.TransportOfPeopleSemiSkilledWorker,
  DriverQualificationsType.TransportOfPeopleForeman,
  DriverQualificationsType.TransportOfPeopleGarageWorker,
]